import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {LMFormPanelBase} from './lm-form-panel-base';
import {LMFormComponent, LMFormTransactionEvent} from './lm-form.component';
import {LMBusyIndicatorService} from '@services/lm-busyindicator.service';
import {Observable, Observer} from 'rxjs';
import {LMPanelTransactionEvent} from './services';
import {LMUrlInfoBuilderService} from '@services/lm-url-info-builder.service';
import {LMRefreshRequest} from '@app/components';

@Component({
  selector: 'lm-form-panel-actionis',
  template: `
    <lm-form *ngIf="activated"
        [formUrlInfo]="formUrlInfo"
        [formSpec]="formSpec"
        [formOptions]="{}"
        [fromDataView]="fromDataView"
        [actionIsAction]="targetAction"
        [hideLayout] = "hideLayout"
        (formRendered)="onFormRendered()"
        (contentModified)="onContentModified($event)"
        (formTransactionEvent)="onPanelTransactionEvent($event)">
    </lm-form>
  `,
})
export class LMFormPanelActionIsComponent implements OnInit, OnDestroy, LMFormPanelBase {
  @ViewChild(forwardRef(() => LMFormComponent)) private lmFormComponent; // : LMFormComponent;

  @Input() formSpec: LMFormSpec = null;
  @Input() formOptions: LMFormOptions;
  @Input() targetAction: string;
  @Input() placeHolder: ViewContainerRef;
  @Input() needsReload: boolean;
  @Input() panelDataState: LMPanelDataState;
  @Input() activated: boolean;
  @Input() panelId: string;
  @Input() hideLayout = false;

  @Input() set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
  }

  get fromDataView(): LMDataView {
    if (this.needsReload || (this.panelDataState === 'stale_needsReload')) {
      // -------------------------------------------------------------
      // return null fromDataView so tabs non activated tabs will
      // not load their data data.
      // -------------------------------------------------------------
      return null;
    }

    return this._fromDataView;
  }

  @Output() contentModified = new EventEmitter<any>();
  @Output() componentDisplayed = new EventEmitter<any>();
  @Output() fieldEvent = new EventEmitter<LMFieldEvent>();
  @Output() formPanelContentLoaded = new EventEmitter<any>();
  @Output() panelTransactionEvent = new EventEmitter<LMPanelTransactionEvent>();

  private _fromDataView: LMDataView;
  public formUrlInfo: LMFormUrlInfo;

  constructor(
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec, { formPanelActionIs: true });
  }

  ngOnDestroy() {
  }

  onContentModified(event: any) {
    this.contentModified.emit(event);
  }

  onPanelTransactionEvent(event: LMFormTransactionEvent) {
    const originatingPanel = this.panelId;
    const panelTransactionEvt = new LMPanelTransactionEvent(originatingPanel);
    this.panelTransactionEvent.emit(panelTransactionEvt);
  }

  onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }

  public getPanelHeight(): number {
    if (this.elementRef) {
      return this.elementRef.nativeElement.offsetHeight;
    }
    return 0;
  }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (this.lmFormComponent) {
        this.lmFormComponent.runRefresh(observer);
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  // ActionIs form saves even if it is NOT dirty because we do not want to force
  // user to change a value to run the action
  public save(callBack: Observer<boolean>, skipToast?: boolean) {
    if (this.lmFormComponent) {
      this.lmFormComponent.runActionSpec(this.targetAction, callBack, skipToast);
    } else {
      callBack.next(true);
      callBack.complete();
    }
  }

  public isDirty(): boolean {
    return this.lmFormComponent ? this.lmFormComponent.isModified() : false;
  }

  saveCompositeComponentState(): void {
    // noop
  }

  clearCompositeComponentState(): void {
    // noop
  }

  onFormRendered() {
    this.lmBusyIndicatorService.hideBusyIndicator();
  }
}
